<template>
  <div class="location-loader">
    <div class="topbar">
      <UIGradientLoader :dark="true" />
    </div>
    <div class="stationsandcalendar">
      <div class="row">
        <div class="stationlist">
          <UIGradientLoader :dark="true" />
        </div>
        <div class="calendarrow">
          <UIGradientLoader :dark="true" />
        </div>
      </div>
      <div class="row">
        <div class="stationlist">
          <UIGradientLoader :dark="true" />
        </div>
        <div class="calendarrow">
          <UIGradientLoader :dark="true" />
        </div>
      </div>
      <div class="row">
        <div class="stationlist">
          <UIGradientLoader :dark="true" />
        </div>
        <div class="calendarrow">
          <UIGradientLoader :dark="true" />
        </div>
      </div>
      <div class="row">
        <div class="stationlist">
          <UIGradientLoader :dark="true" />
        </div>
        <div class="calendarrow">
          <UIGradientLoader :dark="true" />
        </div>
      </div>
      <div class="row">
        <div class="stationlist">
          <UIGradientLoader :dark="true" />
        </div>
        <div class="calendarrow">
          <UIGradientLoader :dark="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UIGradientLoader from '@/core/shared/components/ui/UIGradientLoader';

@Component({
  components: {
    UIGradientLoader,
  },
})
export default class LocationLoader extends Vue {}
</script>

<style lang="postcss" scoped>
@import 'core/shared/styles';

.location-loader {
  & .topbar {
    padding: var(--spacingSm);
  }

  & .row {
    display: flex;

    & .ui-gradient-loader {
      height: 13rem;
    }

    & .stationlist {
      flex: 0 0 35rem;
    }

    & .calendarrow {
      flex: 1 1 auto;
    }
  }
}
</style>
